import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getCurrentTimeAndDurationStyleObject } from './currentTimeAndDuration.style';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../../common/hooks/useStyles';
import { adsDataSelector } from '../../../../common/store/selectors/adsData.selector';
import { css } from '../../../../common/styles/styles.utils';
import { getTimeId } from '../../htmlElements/htmlElementsIdGetter';
import { getTimePresentation } from '../../../../common/utils/utils';

export const CurrentTimeAndDuration: FunctionComponent = () => {
  const playerSize = useSelector(playerDataSelector.playerSize);
  const currentVideoTime = useSelector(playerDataSelector.currentVideoTime);
  const currentVideoDuration = useSelector(playerDataSelector.currentVideoDuration);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const adCurrentTime = useSelector(adsDataSelector.adCurrentTime);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);

  const showAdControls = isVastAd && adBreak;
  const currentTime = showAdControls ? adCurrentTime : currentVideoTime;

  const styles = useStyles(getCurrentTimeAndDurationStyleObject, [playerSize, showAdControls]);
  const { currentTimeAndDurationStyle } = styles;

  return (
    <div style={css(currentTimeAndDurationStyle)} id={getTimeId(playerUniqueId)}>
      {getTimePresentation(Math.floor(currentTime))}
      {
        showAdControls
          ? null
          : ` / ${getTimePresentation(Math.floor(currentVideoDuration))}`
      }
    </div>
  );
};
